import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
export var useSearchStore = create()(devtools(function (set) { return ({
    search: '',
    setSearch: function (search) { return set(function (_) { return ({ search: search }); }); },
}); }));
